module.exports = __webpack_public_path__ + "img/8th_jobs-and-careers.6fec43be.webp";